var map = {
	"./1.mp4": "cc12",
	"./do-2.mp4": "7512",
	"./do.mp4": "4199",
	"./fa.mp4": "e4b8",
	"./la.mp4": "f85a",
	"./mi.mp4": "958c",
	"./re.mp4": "e9b6",
	"./si.mp4": "2c9a",
	"./sol.mp4": "f3ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e51";